import { render, staticRenderFns } from "./VisualizacionPopularidadArtistas.vue?vue&type=template&id=a161da2a&scoped=true&"
import script from "./VisualizacionPopularidadArtistas.vue?vue&type=script&lang=js&"
export * from "./VisualizacionPopularidadArtistas.vue?vue&type=script&lang=js&"
import style0 from "./VisualizacionPopularidadArtistas.vue?vue&type=style&index=0&id=a161da2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a161da2a",
  null
  
)

export default component.exports